import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Alert,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { usePlanillonStore } from '../store';
import PlanillonToolbar from './PlanillonToolbar';
import PlanillonGrid from './PlanillonGrid';
import EditPlanilla from './EditPlanilla';

const PlanillonPage: React.FC = () => {
  const {
    error,
    dialogOpen,
    fetchPeriodos,
    closeDialog,
    clearError,
  } = usePlanillonStore();

  useEffect(() => {
    fetchPeriodos();
  }, [fetchPeriodos]);

  return (
    <Box sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
      {/* Header */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
          Planillón
        </Typography>
        <PlanillonToolbar />
      </Box>

      {/* Error */}
      {error && (
        <Alert
          severity="error"
          sx={{ mb: 2 }}
          action={
            <IconButton size="small" onClick={clearError}>
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        >
          {error}
        </Alert>
      )}

      {/* Grid */}
      <PlanillonGrid />

      {/* Dialog para nueva planilla */}
      <EditPlanilla open={dialogOpen} onClose={closeDialog} />
    </Box>
  );
};

export default PlanillonPage;
